export default __webpack_public_path__ + "static/media/icon_artifact_small_orange.a8a8aa85.svg";